import Handlebars from 'handlebars';

const NS = 'WoolMoreArticlesBlock';
const CLS = 'woolMoreArticlesBlock';

export class WoolMoreArticlesBlock {
	constructor(element) {
		this.element = element;
		this.$el = $(element);

		this.$articles = this.$el.find(`.${CLS}-articles`);
		this.$categoryDropdown = this.$el.find(`select.${CLS}-control-category`);
		this.$loadMore = this.$el.find(`.${CLS}-loadMore`);
		this.$spinner = this.$el.find(`.${CLS}-spinner`);
		this.$emptyMessage = this.$el.find(`.${CLS}-empty`);

		this.getArticlesApi = this.$el.data('articlesApi');
		this.isLoadingArticles = false;

		this.pageNumber = 1;

		this.initParams();
		this.eventHandler();
		this.getArticles();
	}

	initParams(){
		this.params = {
			count: 6,
			offset: 0,
			category: this.$categoryDropdown.val()
		};
	}

	eventHandler() {
		this.$loadMore.on('click', () => {
			this.pageNumber++;
			this.getArticles(true);
		});

		this.$categoryDropdown.on('change', () => {
			this.params.category = this.$categoryDropdown.val();
			this.pageNumber = 1;
			this.getArticles(false);
		});
	}
	
	getArticleCardBlockTemplate() {
		let articleCardBlock = require('../../articleCardBlock/tmpl/articleCardBlock.hbs');
		Handlebars.registerPartial('articleCardBlock', articleCardBlock);

		let template = `
			{{> articleCardBlock
				wg="articleCardBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		return Handlebars.template(precompiled);
	}

	getArticles(isLoadMore) {
		if (this.isLoadingArticles) {
			return;
		}

		this.params.offset = (this.pageNumber - 1) * this.params.count;
		let url = `${this.getArticlesApi}?category=${this.params.category}&count=${this.params.count}&offset=${this.params.offset}`;

		this.isLoadingArticles = true;
		this.$spinner.show();
		this.$loadMore.hide();

		$.ajax({
			type: 'GET',
			url: url,
			success: (data) => {
				this.isLoadingArticles = false;
				this.$spinner.hide();
				this.$loadMore.show();
				this.$emptyMessage.hide();

				if (!isLoadMore){
					this.$articles.html('');
				}

				data.results.forEach((item) => {
					item["wg"] = "articleCardBlock";
					this.$articles.append(this.getArticleCardBlockTemplate()(item));
				});

				if (this.pageNumber === 1 && !(data.results && data.results.length)) {
					this.$emptyMessage.show();
				}

				if (data.results.length < this.params.count) {
					this.$loadMore.hide();
				} 
			},
			error: (res, error) => {
				this.$spinner.hide();
				console.log("error loading articles", error);
			},
			complete: () => {
				this.$spinner.hide();
				this.isLoadingArticles = false;
			},
		});	
	}
}
